import ApiUrls from "./axr";
import { dwLogging } from "../../../shared/hooks/useFetchLogin";
import store from "../SharedContextStore/store";
import { setHeaders } from "../SharedContextStore/slices/brightspeedToken";
import useBrightspeedUser from "../hooks/useUser";

interface DWLogMain {
  sessionId?: string;
  stepName: string; 
}

interface DwLogutilProps extends DWLogMain {
  headers?: Object;
  email?: string;
  companyName?: any;
  error?: any;
  flowType?: string;
  response?: string;
  searchText?:string;
  fsId?:string;
  isPostpaidFiber?:boolean;
  billingType?: string;
  message?: string;
  otpchannel?: string;
  category?: string;
  info?: string;
};

interface DwLogBody extends DWLogMain {
  [x: string]: string | undefined | boolean;
  cta: string;
  userEmail?: string
  customerType: any
  otpchannel?: string
  screenType?: string
};

const getScreenType = (): string => {
  if (typeof navigator === "undefined") return "Web";

  const ua = navigator.userAgent || "";
  const uaDataMobile = (navigator as any)?.userAgentData?.mobile;
  const isMobile =
    uaDataMobile === true ||
    /Android|iPhone|iPad|iPod|IEMobile|BlackBerry|Opera Mini|Mobile/i.test(ua);

  return isMobile ? "Mobile" : "Web";
};

const userFromStore = function(store: any){
  const address = store?.user?.data?.addresses?.filter((address: any) => address?.addressType === "ServiceAddress")
  return {
    state: address?.[0]?.state,
    customerType: store?.user?.data?.siteId
  }
}

const DwLogutil = ({
  headers,
  sessionId,
  email,
  companyName, 
  stepName,
  error,
  flowType,
  response,
  searchText,
  fsId,
  message,
  otpchannel,
  category,
  info,
}: DwLogutilProps) => {
  if ( !(stepName) ) {
    console.info('DW Log missing Step Name');
    return
  };

  const endpoint = { "" : ApiUrls?.dwLoggingUrl };

  const reduxStore = store.getState();
  const headerFromStore = (reduxStore as any)?.brightspeedToken?.headers;
  const sessionIdFromStore = reduxStore?.user?.sessionId;
  const emailIdFromStore = reduxStore?.user?.data?.email;
  const loggedInEmail= reduxStore?.user?.logedinUserName;
  const companyNameFromStore = reduxStore?.user?.companyName;
  const isPostPaidFiberUser = reduxStore?.brightSpeedUserUtils?.isPostPaidFiberUser;
  const isPostPaidFiberNonAuthFlag = reduxStore?.userAccountSlice?.isPostPaidFiberFlag;
  const billingType = reduxStore?.brightSpeedUserUtils?.billingType;
  const headersSiteId:any=localStorage.getItem("headersSiteId")
  const originUrl = window.location.href; 
  const unAuthCustomerType =
  headersSiteId === "bs"
      ? "Brightspeed"
      : headersSiteId === "qf"
      ? "Quantum Fiber"
      : headersSiteId === "ctl"
      ? "Century Link"
      : ""

  let newStepName = stepName;
  const body: DwLogBody = {
    stepName: newStepName,
    cta : error ? 'Failed' : 'Success',
    sessionId : sessionStorage?.getItem("sessionId") ||  sessionId || sessionIdFromStore,
    customerType: localStorage.getItem("headersSiteId") || companyName || companyNameFromStore || unAuthCustomerType,
    billingType: billingType,
    message: message,
    screenType: getScreenType(),
  };

  // if(stepName && billingType === "postpaid" && (body.customerType === "bs" || body.customerType === "qf") ) {
  //   body.stepName = `PPF ${stepName}`;
  // }
  
  if(flowType) {
    body.flowType = flowType;
  }

  if(response){
    body.response = response;
  }

  if(searchText){
    body.searchText = searchText;
  }

  if(fsId){
    body.fsId = fsId
  }
  
  if(isPostPaidFiberUser || isPostPaidFiberNonAuthFlag){
    body.isPostpaidFiber = true;
  }

  if(category) {
    body.category = category;
  }

  if(info) {
    body.info = info;
  }

  if (error) {
    body.error =
      typeof error === "string"
        ? error
        : error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "Unknown error";
  }
  if(message) body.message = message
  if(otpchannel) body.otpchannel = otpchannel

  return dwLogging(
    endpoint, 
    body, 
    headers || headerFromStore
  );
}


export const setCompanyNameWithHeader = (companyName: any, existingHeaders: any ) => {
  let siteIdTemp = ''
  if(companyName?.toUpperCase() === "QUANTUM FIBER") {
    siteIdTemp = 'qf'
  } else if (companyName?.toUpperCase() === "BRIGHTSPEED") {
    siteIdTemp = 'bs'
  } else if (companyName?.toUpperCase() === "CENTURY LINK") {
    siteIdTemp = 'ctl'
  } else {
    siteIdTemp = companyName;
  }
  store?.dispatch(
    setHeaders({
      ...existingHeaders,
      siteId: siteIdTemp,
    })
  );
}

export default DwLogutil
